import firebase from '@/firebase'
const db = firebase.firestore();
import { FS_COLLECTIONS } from '@/firebase'

const store = {
  state: {
    planBienestar:[],
  },
  getters: {
    planBienestar: state => {
      return state.planBienestar;
    }
  },
  mutations: {
    ASIGNA_PLAN_BIENESTAR(state, planBienestar){
      state.planBienestar = planBienestar;
    }
  },
  actions: {
    cargaPlanBienestar({commit,getters},id){
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS)
        .doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.PLANES_BIENESTAR)
        .doc(id).get()
          .then(doc => {
            console.log("Plan bienestar: " +doc.data());
            commit('ASIGNA_PLAN_BIENESTAR', doc.data())
            resolve(doc.data());
          })
          .catch(error => {
            console.error('Error obteniendo Usuario: ', error)
            reject(error)
          })
      })
    },
    guardarPlanBienestar({getters}, plan){
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.PLANES_BIENESTAR).add(plan).then(() => {
          resolve()
        }).catch(error => {
          reject(error);
        })
      })
    },
    actualizarPlanBienestar({getters}, {plan,id}){
      return new Promise((resolve, reject) => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.PLANES_BIENESTAR).doc(id).set(plan).then(() => {
          resolve();
        }).catch(error => {
          reject(error);
        })
      })
    }
  }
}
export default store



// WEBPACK FOOTER //
// ./src/store/planes_bienestar/plan_bienestar.js